export default __webpack_public_path__ + "static/media/Pane.d7995b86.svg";